import Mousetrap from "mousetrap";
import { EventBus } from "../eventbus";
import { copy, paste } from "./copyPaste";
import { deleteSelected } from "./DeleteItems";

const shortcuts = [
  {
    name: "copy",
    command: ["command+c", "ctrl+c"],
    func: (vueThis) => {
      copy(vueThis);
    },
  },
  {
    name: "paste",
    command: ["command+v", "ctrl+v"],
    func: (vueThis) => {
      paste(vueThis);
    },
  },
  {
    name: "delete",
    command: ["del", "backspace"],
    func: (vueThis) => {
      deleteSelected(vueThis);
    },
  },
];

const listenForAllKeys = () => {
  document.addEventListener("keypress", (e) => {
    EventBus.$emit("keypress", e.key);
  });
};

const listenForKeys = (vueThis) => {
  listenForAllKeys();

  shortcuts.forEach((shortcut) => {
    Mousetrap.bind(shortcut.command, () => {
      shortcut.func(vueThis);
    });
  });
};

export default listenForKeys;
